import { create } from 'zustand';
import type { UserRole } from '../types';

interface User {
  id: string;
  email: string;
  name: string;
  photoUrl?: string;
  department?: string;
  role: UserRole;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isBootstrapped: boolean;
  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: localStorage.getItem('token'),
  // We only consider the user authenticated once we've successfully
  // loaded their profile (bootstrap) with a valid token.
  isAuthenticated: false,
  isBootstrapped: false,
  setUser: (user) =>
    set((state) => {
      // Ensure we have the token from state or localStorage
      const token = state.token || localStorage.getItem('token');
      return {
        user,
        isAuthenticated: !!user && !!token,
        isBootstrapped: true,
      };
    }),
  setToken: (token) => {
    if (token) {
      localStorage.setItem('token', token);
      set({
        token,
        // We will verify this token via /api/auth/me during bootstrap
        // before marking the user as authenticated.
        isAuthenticated: false,
        user: null,
        isBootstrapped: false,
      });
    } else {
      localStorage.removeItem('token');
      set({
        token: null,
        isAuthenticated: false,
        user: null,
        isBootstrapped: true,
      });
    }
  },
  logout: () => {
    localStorage.removeItem('token');
    set({
      user: null,
      token: null,
      isAuthenticated: false,
      isBootstrapped: true,
    });
  },
}));

